import { SgwtHelpCenterHTMLElement } from './sgwt-widgets';

const regexTopic = /top\..+/;
const regexCategory = /cat\..+/;

export const openHelpCenter = (id?: string): void => {
  const widget: SgwtHelpCenterHTMLElement | null = document.querySelector('sgwt-help-center');
  if (widget && !!widget.open) {
    if (id && id.match(regexTopic) !== null) {
      widget.topic(id);
    } else if (id && id.match(regexCategory) !== null) {
      widget.category(id);
    } else if(id && id === 'contact-us') {
      widget.form();
    } else {
      widget.open();
    }
  }
};